module.exports = __webpack_public_path__ + "static/img/004.c934d88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory/004.jpg
// module id = d6sT
// module chunks = 1